import * as HttpService from "../services/common-services/HttpService";

export function getReferralDoctor() {
  return HttpService.get("api/v1/ReferralDoctors");
}

export function getReferralDoctorsCount() {
  return HttpService.get("api/v1/referraldoctors/count");
}
